/**
 * PLP Product Card — Grid View
 * Image (1:1) → Title (2 lines) → Rating (always) → Price + action button row.
 * Button logic: See Details | Notify Me | Request a Quote | View Options | Add to Cart
 */
(function () {
  const { html, useState, useEffect } = window.preact;

  var QUOTE_URL = 'https://hrmenterprises.formstack.com/forms/waterpumps';

  function AmishIcon() {
    return html`
      <svg width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.97539 5.41506L5.9825 0.92575C6.02692 0.56127 6.38587 0.0961395 6.75253 0.0276504C7.11503 -0.0396475 8.33938 0.483847 8.80198 0.595216C10.7087 1.0538 11.3425 0.270638 13.017 0.018717C13.7361 -0.0896743 13.9481 0.280167 14.0323 0.934684L14.0654 5.42757C15.5836 5.67889 17.2403 5.80217 18.6755 6.39058C19.4112 6.69193 20.5189 7.3137 19.7275 8.19452C18.6228 9.42435 14.0068 9.8597 12.3542 9.95261C9.74438 10.0991 2.59023 9.98953 0.53899 8.42739C-0.746365 7.44889 0.552021 6.67824 1.511 6.31554C2.92549 5.78073 4.49279 5.6503 5.97657 5.41506H5.97539ZM13.4926 0.493972C13.4233 0.422505 13.2279 0.412976 13.1278 0.4231C12.4217 0.496354 11.4177 0.96744 10.666 1.10859C9.96354 1.2408 9.47724 1.18124 8.78955 1.02402C8.4377 0.943617 6.98768 0.394514 6.81176 0.44454C6.71106 0.473127 6.48242 0.69527 6.44333 0.793537L6.42556 7.27201C8.72084 7.94141 11.3064 7.783 13.6188 7.26427L13.6265 1.04427C13.617 0.927537 13.559 0.563056 13.4926 0.494567V0.493972ZM5.98368 5.89984C4.68352 5.98024 3.26015 6.18333 2.01567 6.58533C1.46006 6.76459 -0.161143 7.30059 0.684111 8.04266C1.80361 9.02592 6.13236 9.444 7.673 9.53215C10.6595 9.70307 14.5535 9.578 17.4411 8.81331C18.1987 8.61261 20.597 7.95094 19.0552 7.02128C18.5221 6.69968 17.7189 6.50076 17.1094 6.35723C16.119 6.12377 15.0534 5.95166 14.04 5.89984V7.47807C13.9037 7.65019 13.6703 7.68413 13.4695 7.73833C11.6712 8.22728 8.51885 8.27135 6.71699 7.81337C6.47709 7.75203 6.191 7.67699 5.98427 7.53763V5.89984H5.98368Z" fill="white"/>
      </svg>
    `;
  }

  function FlagIcon() {
    return html`
      <svg width="18" height="13" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 6h15M1 1h15M1 11h15" stroke="#fff" stroke-width="1.5"/>
        <rect x="0" y="0" width="7" height="5" fill="#fff" opacity="0.3"/>
      </svg>
    `;
  }

  function CartIcon() {
    return html`
      <svg width="16" height="15" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.809486 0C0.362419 0 0 0.350238 0 0.782279C0 1.21432 0.362419 1.56456 0.809486 1.56456H1.08372C1.30361 1.5646 1.62203 1.75188 1.70752 2.20289L1.70839 2.20737L4.06154 14.2265C4.14466 14.651 4.56813 14.93 5.00741 14.8497C5.02754 14.846 5.04736 14.8416 5.06684 14.8366C5.0888 14.8383 5.11101 14.8392 5.13343 14.8392H15.2328C15.4045 14.8391 15.5535 14.8449 15.7101 14.8509C15.794 14.8542 15.8801 14.8575 15.973 14.8601C16.2104 14.8667 16.4947 14.8681 16.7707 14.8168C17.064 14.7624 17.3785 14.6434 17.6491 14.3909C17.9132 14.1444 18.0731 13.8285 18.1713 13.4852C18.1786 13.4597 18.1845 13.434 18.1891 13.408L19.3823 6.62485C19.6323 5.64018 18.8354 4.69357 17.8003 4.69368H3.84285L3.3 1.92098L3.29953 1.91854C3.10141 0.879133 2.23547 6.64908e-05 1.08381 0H0.809486ZM4.14917 6.25823L5.52288 13.2747H15.2327C15.4357 13.2746 15.6439 13.2826 15.8178 13.2891C15.8921 13.2919 15.9607 13.2946 16.0194 13.2962C16.2451 13.3024 16.3765 13.2969 16.4652 13.2804C16.5006 13.2738 16.5183 13.2675 16.5257 13.264C16.5335 13.2552 16.5652 13.2141 16.6007 13.1022L17.792 6.33009C17.7959 6.30798 17.8008 6.28604 17.8066 6.26434C17.8039 6.26103 17.8012 6.25908 17.7998 6.25823H4.14917ZM8.79636 17.5486C8.79636 18.2257 8.25271 18.7747 7.58212 18.7747C6.91151 18.7747 6.36789 18.2257 6.36789 17.5486C6.36789 16.8714 6.91151 16.3225 7.58212 16.3225C8.25271 16.3225 8.79636 16.8714 8.79636 17.5486ZM14.5746 18.7747C15.2452 18.7747 15.7889 18.2257 15.7889 17.5486C15.7889 16.8714 15.2452 16.3225 14.5746 16.3225C13.904 16.3225 13.3604 16.8714 13.3604 17.5486C13.3604 18.2257 13.904 18.7747 14.5746 18.7747Z" fill="currentColor"/>
      </svg>
    `;
  }

  function MailIcon() {
    return html`
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.125 5.625V14.375C18.125 14.8723 17.9275 15.3492 17.5758 15.7008C17.2242 16.0525 16.7473 16.25 16.25 16.25H3.75C3.25272 16.25 2.77581 16.0525 2.42417 15.7008C2.07254 15.3492 1.875 14.8723 1.875 14.375V5.625M1.875 5.625V5.82833C1.87496 6.14845 1.95689 6.46325 2.11297 6.74275C2.26906 7.02224 2.4941 7.25711 2.76667 7.425L9.01667 11.27C9.31233 11.4521 9.65275 11.5485 10 11.5485C10.3472 11.5485 10.6877 11.4521 10.9833 11.27L17.2333 7.42417C17.5059 7.25628 17.7309 7.0214 17.887 6.74191C18.0431 6.46242 18.125 6.14762 18.125 5.8275V5.625C18.125 5.12772 17.9275 4.65081 17.5758 4.29917C17.2242 3.94754 16.7473 3.75 16.25 3.75H3.75C3.25272 3.75 2.77581 3.94754 2.42417 4.29917C2.07254 4.65081 1.875 5.12772 1.875 5.625Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
  }

  function hasTag(tags, name) {
    return tags && tags.some(function (t) { return t === name; });
  }

  // Merchant-specified SKUs that must behave like call-to-order (no price, "See Details"),
  // independent of product tags. Single source of truth shared with the list card.
  var CALL_TO_ORDER_SKUS = window.PlpCallToOrderSkus || (window.PlpCallToOrderSkus = [
    '100016917', '1721828', '100040090', '351810', '351429', '100039321', '100017361', '100023981'
  ]);
  function isCallToOrderSku(product) {
    return !!(product && product.sku && CALL_TO_ORDER_SKUS.indexOf(String(product.sku)) !== -1);
  }

  function ProductCardGrid({ product, onAddToCart }) {
    var hasPriceRange = product.variantsCount > 1 && product.priceMin != null && product.priceMax != null && product.priceMin !== product.priceMax;
    var price = hasPriceRange
      ? window.PlpMockData.formatPrice(product.priceMin) + ' - ' + window.PlpMockData.formatPrice(product.priceMax)
      : window.PlpMockData.formatPrice(product.price);
    var hasCompare = !hasPriceRange && product.compareAtPrice != null && product.compareAtPrice > 0 && product.compareAtPrice > product.price;
    var comparePrice = hasCompare ? window.PlpMockData.formatPrice(product.compareAtPrice) : null;

    // Discount state — read the resolved discount/availability SYNCHRONOUSLY at
    // mount so a re-mounting card (filter change, or a product that left the
    // resultset and reappears on a later search) paints its cached state on the
    // FIRST render — no null→discount flash while a post-paint useEffect catches
    // up. The StorefrontClient cache (localStorage mirror, initialised in
    // <head>) is the reliable source on a reload; __algoliaDiscounts additionally
    // carries the OOS-sibling substitutions/availability the unified cache omits.
    var variantId = String(product.variantId);
    var handle = product.handle;
    function readCachedDiscount(vid) {
      return (window.__algoliaDiscounts && window.__algoliaDiscounts.get(vid))
        || (window.StorefrontClient && window.StorefrontClient.cacheGet && window.StorefrontClient.cacheGet(vid))
        || null;
    }

    var _rd = useState(function () {
      var cr = window.__algoliaRangeDiscounts && window.__algoliaRangeDiscounts.get(handle);
      return cr && cr.hasRangeDiscount ? cr : null;
    });
    var rangeDiscount = _rd[0];
    var setRangeDiscount = _rd[1];
    var _sd = useState(function () {
      var c = readCachedDiscount(variantId);
      return c && c.hasDiscount ? c : null;
    });
    var singleDiscount = _sd[0];
    var setSingleDiscount = _sd[1];
    // Algolia's representative variant can be out of stock while a sibling is
    // purchasable — the discount checker flags those (productAvailable) so the
    // card doesn't show "Notify Me" for a product the PDP sells.
    var _fa = useState(function () {
      var c = readCachedDiscount(variantId);
      return !!(c && c.productAvailable);
    });
    var forcedAvailable = _fa[0];
    var setForcedAvailable = _fa[1];

    useEffect(function () {
      function onRange(e) {
        if (e.detail.handle === handle && e.detail.hasRangeDiscount) setRangeDiscount(e.detail);
      }
      function onSingle(e) {
        if (String(e.detail.variantId) !== variantId || !e.detail.discountInfo) return;
        if (e.detail.discountInfo.hasDiscount) setSingleDiscount(e.detail.discountInfo);
        if (e.detail.discountInfo.productAvailable) setForcedAvailable(true);
      }

      // Re-read on variant change (component reuse) and keep listening for late
      // resolutions — same synchronous source as the lazy initial state.
      var cached = readCachedDiscount(variantId);
      if (cached && cached.hasDiscount) setSingleDiscount(cached);
      if (cached && cached.productAvailable) setForcedAvailable(true);
      var cachedRange = window.__algoliaRangeDiscounts && window.__algoliaRangeDiscounts.get(handle);
      if (cachedRange && cachedRange.hasRangeDiscount) setRangeDiscount(cachedRange);

      document.addEventListener('algolia.discount.range', onRange);
      document.addEventListener('algolia.discount.resolved', onSingle);
      return function () {
        document.removeEventListener('algolia.discount.range', onRange);
        document.removeEventListener('algolia.discount.resolved', onSingle);
      };
    }, [product.handle, product.variantId]);

    var isSoldOut = !product.available && !forcedAvailable;
    var isQuote = hasTag(product.tags, 'quote-form');
    var isCustomizable = hasTag(product.tags, 'Customizable');
    var isSkuCallToOrder = isCallToOrderSku(product);
    var isCallToOrder = hasTag(product.tags, 'call-to-order') || isSkuCallToOrder;
    var isGiftCard = window.PlpIsGiftCardProduct
      ? window.PlpIsGiftCardProduct(product)
      : product.productType === 'Gift Cards';
    var isMultiVariant = product.variantsCount > 1;

    function handleAtc(e) {
      e.preventDefault();
      if (onAddToCart) onAddToCart(product.variantId, 1);
    }

    // Badge flags (one badge shows, priority resolved in PlpBadge):
    //   low stock → representative variant inventory in (0, threshold]; sale → any discount/compare-at.
    var isLowStock = !!(product.available && product.inventoryQuantity != null && product.inventoryQuantity > 0 && product.inventoryQuantity <= (window.PLP_LOW_STOCK_THRESHOLD || 20));
    var isOnSale = hasCompare || !!singleDiscount || !!rangeDiscount;
    var badgeNode = html`<${window.PlpBadge} product=${product} prefix="plp-card-grid" lowStock=${isLowStock} onSale=${isOnSale} />`;

    var cfg = window.algoliaConfig || {};
    var paymentsLayout = !!(cfg.showBuyLater || cfg.showWarranty);
    var showPaymentBars = paymentsLayout && !isGiftCard && window.PlpPaymentsBars;
    var paymentsNode = showPaymentBars
      ? html`<${window.PlpPaymentsBars} handle=${handle} variantId=${variantId} />`
      : paymentsLayout && window.PlpPaymentsBars
        ? html`<${window.PlpPaymentsBars} layoutOnly=${true} />`
        : null;

    var actionButton;
    if (isCallToOrder || isCustomizable) {
      actionButton = html`
        <a href="${product.url}" class="plp-card-grid__action-link" aria-label="See details for ${product.title}">
          <span>See Details</span>
        </a>
      `;
    } else if (isSoldOut) {
      actionButton = html`
        <button class="plp-card-grid__notify" onClick=${function(e) { e.preventDefault(); if (window.PlpNotifyMe) window.PlpNotifyMe(product.sku || product.variantId); }} aria-label="Notify me about ${product.title}">
          <span><${MailIcon} /> Notify Me</span>
        </button>
      `;
    } else if (isQuote) {
      actionButton = html`
        <a href="${QUOTE_URL}" target="_blank" rel="noopener" class="plp-card-grid__quote-link" aria-label="Request a quote for ${product.title}">
          <span>Request a Quote</span>
        </a>
      `;
    } else if (isGiftCard || isMultiVariant) {
      actionButton = html`
        <a href="${product.url}" class="plp-card-grid__action-link" aria-label="View options for ${product.title}">
          <span>View Options</span>
        </a>
      `;
    } else {
      actionButton = html`
        <button class="plp-card-grid__atc" onClick=${handleAtc} aria-label="Add ${product.title} to cart">
          <span><${CartIcon} /> Add to Cart</span>
        </button>
      `;
    }

    return html`
      <div class="plp-card-grid${paymentsLayout ? ' plp-card-grid--payments' : ''}">
        <a href="${product.url}" class="plp-card-grid__image-wrap">
          <img
            src="${product.image}"
            alt="${product.title}"
            loading="lazy"
            width="247"
            height="247"
          />
          ${badgeNode}
        </a>
        <h3 class="plp-card-grid__title">
          <a href="${product.url}">${product.title}</a>
        </h3>
        ${paymentsNode}
        <${window.PlpStarRating} rating=${product.rating || 0} count=${product.ratingCount || 0} />
        <div class="plp-card-grid__bottom">
          ${isSkuCallToOrder ? html`
            <div class="plp-card-grid__prices" aria-hidden="true">
              <span class="plp-card-grid__price" style="visibility:hidden;">&nbsp;</span>
            </div>
          ` : isCallToOrder ? null : rangeDiscount ? (
            rangeDiscount.originalMin === rangeDiscount.originalMax && rangeDiscount.discountMin === rangeDiscount.discountMax ? html`
            <div class="plp-card-grid__prices">
              <span class="plp-card-grid__price plp-card-grid__price--compare">${window.PlpMockData.formatPrice(Math.round(rangeDiscount.originalMin * 100))}</span>
              <span class="plp-card-grid__price plp-card-grid__price--sale">${window.PlpMockData.formatPrice(Math.round(rangeDiscount.discountMin * 100))}</span>
            </div>
          ` : html`
            <div class="plp-card-grid__prices plp-card-grid__prices--stacked">
              <span class="plp-card-grid__price plp-card-grid__price--range-compare">${window.PlpMockData.formatPrice(Math.round(rangeDiscount.originalMin * 100))} - ${window.PlpMockData.formatPrice(Math.round(rangeDiscount.originalMax * 100))}</span>
              <span class="plp-card-grid__price plp-card-grid__price--range-sale">${window.PlpMockData.formatPrice(Math.round(rangeDiscount.discountMin * 100))} - ${window.PlpMockData.formatPrice(Math.round(rangeDiscount.discountMax * 100))}</span>
            </div>
          `
          ) : singleDiscount && !hasPriceRange ? html`
            <div class="plp-card-grid__prices">
              <span class="plp-card-grid__price plp-card-grid__price--compare">${window.PlpMockData.formatPrice(Math.round(singleDiscount.originalPrice * 100))}</span>
              <span class="plp-card-grid__price plp-card-grid__price--sale">${window.PlpMockData.formatPrice(Math.round(singleDiscount.finalPrice * 100))}</span>
            </div>
          ` : html`
            <div class="plp-card-grid__prices">
              <span class="plp-card-grid__price${hasCompare ? ' plp-card-grid__price--sale' : ''}${hasPriceRange ? ' plp-card-grid__price--range' : ''}">${price}</span>
              ${comparePrice ? html`<span class="plp-card-grid__price--compare">${comparePrice}</span>` : null}
            </div>
          `}
          ${actionButton}
        </div>
      </div>
    `;
  }

  window.PlpProductCardGrid = ProductCardGrid;
})();
